import {call, put, takeEvery, all, fork} from 'redux-saga/effects';

import {
  GET_RCA,
  GET_RCA_BY_ID,
  // POST_RCA,
  POST_FULL_RCA,
  UPDATE_RCA_IMPACT,
  UPDATE_RCA_TIMELINE,
  UPDATE_RCA_QUESTIONS,
  UPDATE_RCA_ACTIONS,
  UPDATE_RCA_RELATED_ALERTS,
  UPDATE_RCA_RELATED_RCAS,
  UPDATE_RCA_IMPACTED_APPLICATIONS,
  GET_ACTION_ITEM_BY_ID,
  DELETE_RCA_BY_ID, UPDATE_RCA_INCIDENT_DETAILS, UPDATE_RCA_HEADER_DETAILS, UPDATE_ACTION_STATUS
} from "./actionTypes"

import {
  getRcaSuccess,
  getRcaFail,
  getRcaByIdFail,
  getRcaByIdSuccess,
  // postRcaFail,
  // postRcaSuccess,
  postFullRcaFail,
  postFullRcaSuccess,
  updateRcaImpactFail,
  updateRcaImpactSuccess,
  updateRcaTimelineFail,
  updateRcaTimelineSuccess,
  updateRcaQuestionsFail,
  updateRcaQuestionsSuccess,
  updateRcaActionsFail,
  updateRcaActionsSuccess,
  updateRcaRelatedAlertsFail,
  updateRcaRelatedAlertsSuccess,
  updateRcaRelatedRcasFail,
  updateRcaRelatedRcasSuccess,
  updateRcaImpactedApplicationsFail,
  updateRcaImpactedApplicationsSuccess,
  getActionItemByIdFail,
  getActionItemByIdSuccess,
  deleteRcaByIdSuccess,
  deleteRcaByIdFail,
  updateRcaIncidentDetailsSuccess,
  updateRcaIncidentDetailsFail,
  updateRcaHeaderDetailsFail,
  updateRcaHeaderDetailsSuccess,
  updateActionItemStatus,
  updateActionItemStatusSuccess, updateActionItemStatusFail
} from "./actions"

import {
  getRcaUrl,
  getRcaByIdUrl,
  postRcaUrl,
  postFullRcaUrl,
  updateRcaImpactUrl,
  updateRcaTimelineUrl,
  updateRcaActionsUrl,
  updateRcaQuestionsUrl,
  updateRcaRelatedAlertsUrl,
  updateRcaRelatedRcasUrl,
  updateRcaImpactedApplicationsUrl,
  getActionItemByIdUrl,
  deleteRcaByIdUrl,
  updateRcaIncidentDetailsUrl,
  updateRcaHeaderDetailsUrl,
  updateActionItemStatusUrl
} from "../../helpers/fakebackend_helper"
import {showNotification} from "../../components/Common/notification";
import {error} from "toastr";

function* onGetRca({payload:page_filters}) {
  try {    
      const response = yield call(getRcaUrl, page_filters);
      yield put(getRcaSuccess(response));
  } catch (error) {
      yield put(getRcaFail(error));
  }
}

function* onGetRcaById({payload: id}) {
  try{
    const response = yield call(getRcaByIdUrl, id);
    yield put(getRcaByIdSuccess(response))
  } catch(error) {
    yield put(getRcaByIdFail(error))
  }
}

function* deleteRca({payload: id}) {
    try{
        const response = yield call(deleteRcaByIdUrl, id);
        yield put(deleteRcaByIdSuccess(response))
        if (response){
          showNotification("success", "RCA Deleted Successfully")
          window.location.href = "/RCA?tab=RCA"
        }
    } catch(error) {
        yield put(deleteRcaByIdFail(error))
    }
}

function* onGetActionItemById({payload: id}) {
  try{
    const response = yield call(getActionItemByIdUrl, id);
    yield put(getActionItemByIdSuccess(response))
  } catch(error) {
    yield put(getActionItemByIdFail(error))
  }
}

// function* onPostRca({payload: data}) {
//   try{
//     const response = yield call(postRcaUrl, data);
//     yield put(postRcaSuccess(response))
//   } catch(error) {
//     yield put(postRcaFail(error))
//   }
// }

function* onPostFullRca({payload: data}) {
  try{
    const response = yield call(postFullRcaUrl, data);
    yield put(postFullRcaSuccess(response))
  } catch(error) {
    yield put(postFullRcaFail(error))
  }
}

function* onUpdateRcaImpact({payload: data}) {
  try{
    const response = yield call(updateRcaImpactUrl, data);
    yield put(updateRcaImpactSuccess(response))
  } catch(error) {
    yield put(updateRcaImpactFail(error))
  }
}

function* onUpdateRcaTimeline({payload: data}) {
  try{
    const response = yield call(updateRcaTimelineUrl, data);
    yield put(updateRcaTimelineSuccess(response))
  } catch(error) {
    yield put(updateRcaTimelineFail(error))
  }
}

function* onUpdateRcaActions({payload: data}) {
  try{
    const response = yield call(updateRcaActionsUrl, data);
    yield put(updateRcaActionsSuccess(response))
  } catch(error) {
    yield put(updateRcaActionsFail(error))
  }
}

function* onUpdateRcaQuestions({payload: data}) {
  try{
    const response = yield call(updateRcaQuestionsUrl, data);
    yield put(updateRcaQuestionsSuccess(response))
  } catch(error) {
    yield put(updateRcaQuestionsFail(error))
  }
}

function* onUpdateRcaIncidentDetails({payload: data}) {
  try{
    const response = yield call( updateRcaIncidentDetailsUrl,data);
    yield put(updateRcaIncidentDetailsSuccess(response))
  }catch (error){
    yield put(updateRcaIncidentDetailsFail(error))
  }
}

function* onUpdateRcaHeaderDetails({payload: data}) {
  try{
    const response = yield call(updateRcaHeaderDetailsUrl,data);
    yield put(updateRcaHeaderDetailsSuccess(response))
  }catch (error){
    yield put(updateRcaHeaderDetailsFail(error))
  }
}

function* onUpdateActionItemStatus({payload: data}) {
  try{
    const response = yield call(updateActionItemStatusUrl,data);
    yield put({type: GET_ACTION_ITEM_BY_ID, payload: data.action_item_id});
    yield put(updateActionItemStatusSuccess(response))
  }catch(error){
    yield put(updateActionItemStatusFail(error))
  }
}

function* onUpdateRcaRelatedAlerts({payload: data}) {
  try{
    const response = yield call(updateRcaRelatedAlertsUrl, data);
    yield put(updateRcaRelatedAlertsSuccess(response))
  } catch(error) {
    yield put(updateRcaRelatedAlertsFail(error))
  }
}

function* onUpdateRcaRelatedRcas({payload: data}) {
  try{
    const response = yield call(updateRcaRelatedRcasUrl, data);
    yield put(updateRcaRelatedRcasSuccess(response))
  } catch(error) {
    yield put(updateRcaRelatedRcasFail(error))
  }
}

function* onUpdateRcaImpactedApplications({payload: data}) {
  try{
    const response = yield call(updateRcaImpactedApplicationsUrl, data);
    yield put(updateRcaImpactedApplicationsSuccess(response))
  } catch(error) {
    yield put(updateRcaImpactedApplicationsFail(error))
  }
}

function* rcaSaga() {

  yield takeEvery(GET_RCA, onGetRca);
  yield takeEvery(GET_RCA_BY_ID, onGetRcaById);
  yield takeEvery(GET_ACTION_ITEM_BY_ID, onGetActionItemById);
  // yield takeEvery(POST_RCA, onPostRca);
  yield takeEvery(POST_FULL_RCA, onPostFullRca);
  yield takeEvery(UPDATE_RCA_IMPACT, onUpdateRcaImpact);
  yield takeEvery(UPDATE_RCA_TIMELINE, onUpdateRcaTimeline);
  yield takeEvery(UPDATE_RCA_ACTIONS, onUpdateRcaActions);
  yield takeEvery(UPDATE_RCA_QUESTIONS, onUpdateRcaQuestions);
  yield takeEvery(UPDATE_RCA_INCIDENT_DETAILS, onUpdateRcaIncidentDetails);
  yield takeEvery(UPDATE_RCA_HEADER_DETAILS, onUpdateRcaHeaderDetails);
  yield takeEvery(UPDATE_RCA_RELATED_ALERTS, onUpdateRcaRelatedAlerts);
  yield takeEvery(UPDATE_RCA_RELATED_RCAS, onUpdateRcaRelatedRcas);
  yield takeEvery(UPDATE_RCA_IMPACTED_APPLICATIONS, onUpdateRcaImpactedApplications);
  yield takeEvery(DELETE_RCA_BY_ID, deleteRca);
  yield takeEvery(UPDATE_ACTION_STATUS, onUpdateActionItemStatus);
}

export default rcaSaga;
